import React from 'react'
const CertExcelFileDataTable = ({ fileData, errors }) => {

    if (!fileData.length) {
        return <p>No data available</p>;
    }
    const headers = Object.keys(fileData[0]);

    return (
        <div>
            {errors.length === 0 ? (
                <div className="alert alert-success d-flex align-items-center p-2" role="alert">
                    <i className="bi bi-check-circle mr-1 fs-5"></i>
                    All rows are valid. No errors found!
                </div>
            ) :
                errors?.map((err, ind) => (
                    <div key={ind} className="alert alert-danger mb-3">
                        <strong>Error at row {err.row}:</strong>
                        <ul className="mb-0 mt-2">
                            {err?.errors?.map((msg, i) => (
                                <li key={i}>{msg}</li>
                            ))}
                        </ul>
                    </div>
                ))
            }
            <table className="table table-bordered table-striped table-hover w-100 table">
                <thead className="table-dark">
                    <tr>
                        {headers.map((header) => (
                            <th key={header} scope="col">{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {fileData.map((row, rowIndex) => {
                        let hasError = errors.find(err => err.row === rowIndex + 1)
                        return <tr key={rowIndex} className={`${hasError ? 'bg-danger' : ""}`}>
                            {
                                headers.map((header) => (
                                    <td key={header}>{row[header]}</td>
                                ))
                            }
                        </tr>
                    }
                    )}
                </tbody>
            </table>

        </div >
    );
};

export default CertExcelFileDataTable;
